// This icon file is generated automatically.
var UiwOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5.98 0l4.47 3.42-1.7 5.53H3.2L1.5 3.42 5.98 0zm0 20L1.5 16.58l1.7-5.53h5.54l1.71 5.53L5.98 20zm12.52-7.03l-5.26 1.8-3.25-4.71 3.25-4.7 5.26 1.8v5.8z" } }] }, "name": "uiw", "theme": "outlined" };
export default UiwOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/UiwOutlined.js
// module id = 4298
// module chunks = 0